<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card class="productdetailscard">
          <v-container fluid>
            <v-row>
              <v-col
                cols="12"
                class="d-flex justify-end"
                style="padding: 5px; margin: inherit"
              >
                <permission-control permissionName="Batch Create">
                  <v-btn
                    depressed
                    small
                    height="32"
                    class="btn_blue w-100 ma-6"
                    @click.stop="OpenModal(modalMode)"
                  >
                    <v-icon class="icon_small ma-1">mdi-plus </v-icon>
                    Add
                  </v-btn>
                </permission-control>
                <v-row class="align-right">
                  <TableFilters
                    :filters="[, 'search']"
                    v-model="filter"
                    :columns="false"
                    :clearbutton="false"
                    :msgs="'Batch'"
                  ></TableFilters>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <!-- Filters -->

                <!-- Data table -->
                <v-row>
                  <!-- {{productDetails}} -->
                  <!-- {{ProductBatches}} -->
                  <v-col
                    cols="12"
                    style="padding: 1px; margin-top: -29px"
                    class="textbold"
                  >
                    <v-data-table
                      :items-per-page="paginationOptions.perPage"
                      :headers="columns"
                      :items="productBatchList"
                      item-key="id"
                      hide-default-footer
                      class="row-pointer"
                      @click:row="
                        $router.push(`${$route.params.id}/batch/${$event.id}`)
                      "
                    >
                      <!-- Manufactured Date -->
                      <template v-slot:item.name="{ item }"
                        >{{ item.name }}
                        <v-tooltip top color="blue">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              small
                              @mouseenter="batchDetails(item)"
                              >mdi-alert-circle
                            </v-icon>
                          </template>
                          <div
                            v-for="unit in unitPriceDetails"
                            :key="unit"
                            class="sub-section"
                          >
                            <h5>Unit Name :- {{ unit.name }}</h5>
                            <h5>Barcode :- {{ unit.barcode }}</h5>
                            <h5>
                              Purchase Price :- LKR {{ unit.purchasePrice }}
                            </h5>
                            <h5>
                              Profit Margin :-
                              {{ unit.profit_margin_percentage }}%
                            </h5>
                            <h5>
                              Selling Price :- LKR {{ unit.sellingPrice }}
                            </h5>
                          </div>
                        </v-tooltip>
                      </template>

                      <template
                        v-slot:item.manufacureDate="{ item }"
                        v-slot="{ errors }"
                        name="value"
                        rules="numeric"
                        >{{ item.manufacureDate | formatDate }}</template
                      >

                      <!-- Expired Date -->

                      <template
                        v-slot:item.expiryDate="{ item }"
                        v-slot="{ errors }"
                        name="value"
                        rules="numeric"
                        >{{ item.expiryDate | formatDate }}</template
                      >

                      <!-- No -->
                      <template v-slot:item.no>
                        <v-icon>mdi-vuetify</v-icon>
                      </template>

                      <template v-slot:item.manufacureDate="{ item }">
                        {{ item.manufacureDate | formatDate }}
                      </template>

                      <!-- Status -->
                      <template v-slot:item.status="{ item }">
                        <v-chip
                          label
                          style="
                            background-color: #c11e65;
                            color: white;
                            font-variant-caps: all-small-caps;
                            font-weight: bold;
                          "
                          :color="getStatusColor(item.status)"
                          >{{ item.status }}
                        </v-chip>
                      </template>

                      <template v-slot:footer="{}">
                        <paginationComponent
                          @paginationOptions="setPaginationOptions"
                          :url="`${module}/${$route.params.id}/batches`"
                          @response="receiveBatchResponse"
                          ref="pagination"
                          :paginationAction="false"
                          :filter="filter"
                        />
                      </template>

                      <!-- Action -->
                      <template v-slot:item.action="{ item }">
                        <v-menu offset-y transition="scroll-y-transition">
                          <template v-slot:activator="{ attrs, on }">
                            <v-icon v-bind="attrs" v-on="on"
                              >mdi-dots-vertical
                            </v-icon>
                          </template>
                          <v-list class="actions">
                            <v-list-item
                              v-if="item.is_editable"
                              @click="openConfirmation(item)"
                            >
                              <span>
                                <v-icon v-bind="attrs" v-on="on"
                                  >mdi-archive</v-icon
                                >
                                {{
                                  item.status == 'Active' ? 'Archive' : 'Active'
                                }}
                              </span>
                            </v-list-item>
                            <v-list-item @click="editBatch(item)">
                              <span>
                                <v-icon v-bind="attrs" v-on="on"
                                  >mdi-pencil-box-outline</v-icon
                                >
                                Edit
                              </span>
                            </v-list-item>
                            <v-list-item @click="viewBatch(item)">
                              <span>
                                <v-icon v-bind="attrs" v-on="on"
                                  >mdi-eye</v-icon
                                >
                                View
                              </span>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <BatchForm
      ref="batchForm"
      @conform="refreshBatches()"
      @unitrefresh="refreshunit()"
      :visible="showScheduleForm"
      :productUnits="productUnits"
      :productbatch="ProductBatches"
      :ProductID="id"
      :product="productDetails"
    />
    <!-- </v-container> -->
  </div>
</template>
<script>
import { formatDate } from '@/utils/datehelper';
import BatchForm from './ProductBatchModal';
import { ProductBatch } from '../../../models/ProductBatch';
import { ProductViewModel } from '../../../models/View Models/ProductViewModel';
import _ from 'lodash';
import store from '../../../store/store';
import TableFilters from '@/components/base/TableFilters';
import paginationComponent from '../../shared/components/pagination.vue';
import { ProductBatchViewModel } from '../../../models/View Models/ProductBatchViewModel';
import confirmation from '@/modules/shared/components/confirmation';
import moment from 'moment';
export default {
  data: () => ({
    unitPriceDetails: [],
    paginationOptions: {},
    productDetails: [],

    ProductBatches: [],
    productBatchList: [],
    GetSingleBatch: null,
    productUnits: [],
    selectedSuppliers: [],
    showScheduleForm: false,
    menu: false,
    modalMode: 'create',
    columns: [
      {
        text: 'Batch',
        value: 'name',
        align: 'center',
        width: '20%',
        show: true,
        disabled: false,
      },
      {
        text: 'Manufacture date',
        value: 'manufacureDate',
        align: 'center',
        width: '20%',
        show: true,
        disabled: false,
      },
      {
        text: 'Expiry date',
        value: 'expiryDate',
        align: 'center',
        width: '20%',
        show: true,
        disabled: false,
      },
      {
        text: 'Status',
        value: 'status',
        align: 'center',
        width: '20%',
        show: true,
        disabled: false,
      },
      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
        width: '20%',
      },
    ],
    filter: {
      search: '',
      start: '',
      end: '',
      status: '',
    },
    date_range: [],
    lastRecordOfUnit: {},
  }),

  created() {
    this.GetProductDetails();
    this.LoadlastRecordOfUnit();
  },

  components: { paginationComponent, BatchForm, TableFilters },
  filters: {
    formatDate: function (value) {
      return formatDate(value);
    },
  },
  props: {
    module: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: '',
    },
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    batchDetails(item) {
      this.unitPriceDetails = item.unitPriceDetails;
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshBatches() {
      this.GetProductDetails();
      this.LoadlastRecordOfUnit();
      this.$refs.pagination.refreshData();
    },
    refreshunit() {
      this.GetProductDetails();
    },
    getStatusColor(status) {
      return status == 'Archived' ? 'gray' : 'green';
    },
    // Batch Data Received from pagination component emit function
    receiveBatchResponse(batchData) {
      this.productBatchList = batchData.map((u, i, arr) => {
        u.index = i + 1;
        return new ProductBatchViewModel(u);
      });
    },
    refreshData() {
      if (this.$refs.pagination) {
        this.$refs.pagination.forEach((item) => {
          item.refreshData();
        });
      }
    },
    openConfirmation(batch) {
      confirmation.dialog = true;
      this.$confirm(
        'Do you want to ' +
          (batch.status ? 'Archive  ' : 'Activate  ') +
          batch.name +
          '?',
      ).then((res) => {
        if (res) {
          this.ArchiveActiveBatch(batch);
        }
      });
    },
    ArchiveActiveBatch(batch) {
      this.$store
        .dispatch('product/ArchiveOrActiceProductBatch', {
          productId: this.id,
          batchId: batch.id,
        })
        .then((res) => {
          const msg = batch.status == 'Active' ? 'archive' : 'active';
          this.refreshBatches();
          this.$toast.success('Successfully ' + msg);
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    async GetSingleBatchDetails(productId, batchId) {
      await this.$store
        .dispatch('product/GetProductBatch', {
          product_id: productId,
          batch_id: batchId,
        })
        .then((res) => {
          res.data.productUnits = this.productUnits;
          this.producBatch = new ProductBatchViewModel(res.data);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    GetProductDetails() {
      let productId = this.id;
      this.$store
        .dispatch('product/GetProductById', productId)
        .then((res) => {
          this.Product = res.data;
          this.productDetails = new ProductViewModel(res.data);
          this.productDetails.units[0].barcode = String(new Date().getTime());
          this.productDetails.suppliers.forEach((supplier) => {
            this.selectedSuppliers.push(supplier.id);
          });
          this.lastManufacureDate = this.lastRecordOfUnit.manufacture_date;
          this.lastExpirydate = this.lastRecordOfUnit.expiry_date;
          this.productUnits = this.productDetails.units;
          var x = 0;
          for (var i = 0; i < this.productDetails.units.length; i++) {
            this.productDetails.units[i].purchasePrice =
              this.lastRecordOfUnit.units[i].batch_units.purchase_price;
            this.productDetails.units[i].sellingPrice =
              this.lastRecordOfUnit.units[i].batch_units.selling_price;
            this.productDetails.units[i].barcode = String(
              new Date().getTime() + x++,
            );
          }
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
    OpenModal(mode) {
      if (mode === 'create') {
        this.ProductBatches = new ProductBatch();
        this.batch = '';
      } else {
        this.GetProductDetails();
        this.ProductBatches = new ProductBatch();
        this.ProductBatches.manufacureDate = this.lastManufacureDate
          ? moment(this.lastManufacureDate).format('YYYY-MM-DD')
          : null;
        this.ProductBatches.expiryDate = this.lastExpirydate
          ? moment(this.lastExpirydate).format('YYYY-MM-DD')
          : null;

        this.productUnits = this.productDetails.units;
      }

      this.$refs.batchForm.openModal();

      if (store.state.sitesetting && store.state.sitesetting.siteSettings) {
        this.productUnits.map((productUnit) => {
          productUnit.profit_margin_percentage =
            store.state.sitesetting.siteSettings.profit_margin_percentage;
        });
      }
    },

    LoadlastRecordOfUnit() {
      let productID = this.id;
      this.$store
        .dispatch('product/GetLastBatchById', productID)
        .then((res) => {
          this.lastRecordOfUnit = res.data.data;
        })
        .catch((err) => {
          this.messages.push(err.data.title);
        });
    },
    deleteBatch(item) {},
    clearFilter() {
      this.date_range = [];
    },
    async editBatch(batch) {
      await this.GetSingleBatchDetails(this.id, batch.id);
      this.ProductBatches = this.producBatch;
      this.productUnits = this.ProductBatches.unitPriceDetails;
      this.ProductBatches.isAdd = false;
      this.$refs.batchForm.openModal();
    },
    viewBatch(batch) {
      const id = this.$route.params.id;
      this.$router.push(`${id}/batch/${batch.id}`);
    },
  },
  filters: {
    hasName: function (value) {
      if (has(value, 'name')) return value.name;
      else return '-';
    },
  },
};
</script>

<style scoped>
.textbold {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}

.productdetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>
